export const environment = {
  production: true,
  apiUrl: 'https://elab.nites.rs',
  grafanaUrl: 'https://elab-grafana.nites.rs',
  reportsUrl: 'https://elab.nites.rs'
};
